import React, { useContext, useEffect, useState } from "react";
import classes from "./Services.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import AdjustFontSize from "../../../components/adjust-font-size/AdjustFontSize";
import { NavigationContext } from "../../../App";

const Services = ({ data }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [hoverIndex, setHoverIndex] = useState();
  const navigate = useNavigate();
  const { setIsBackNavigation } = useContext(NavigationContext);

  const [responsiveHtml, setResponsiveHtml] = useState("");
  const width = useDeviceWidth();
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  useEffect(() => {
    //html content will rearrange fontsize when window width changes
    if (data) {
      setResponsiveHtml(AdjustFontSize(data?.description, width));
    }
  }, [data, width]);

  return (
    <div className={classes.servicesContainer} id={sessionStore}>
      <div
        className={classes.headSection}
        data-aos="fade-down"
        data-aos-delay="150"
      >
        <h3 className={classes.ourServices}>{data?.subTitle}</h3>
        {data?.showTitle && (
          <h5
            className={classes.title}
            dangerouslySetInnerHTML={{ __html: data?.title }}
          ></h5>
        )}
        {/* <div className={classes.divideLine}></div> */}
        <h5
          className={classes.description}
          dangerouslySetInnerHTML={{ __html: responsiveHtml }}
        ></h5>
      </div>
      <div className={classes.listSection}>
        {data?.listingItems?.map((service, index) => (
          <div
            key={`${index}${service._id}`}
            className={classes.serviceCard}
            data-aos="fade-right"
            data-aos-delay={index * 10 + 100}
            onClick={() => {
              const yPos = window.scrollY;
            sessionStorage.setItem("scrollTargetY", yPos.toString());
            setIsBackNavigation(true)
            sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
              navigate(`/services/${service?.slug}`)}}
            onMouseEnter={() => {
              setIsHovered(true);
              setHoverIndex(index);
            }}
            onMouseLeave={() => {
              setIsHovered(false);
              setHoverIndex(null);
            }}
            onTouchStart={() => {
              setIsHovered(false);
              setHoverIndex(null);
            }}
          >
            {isHovered && hoverIndex == index && (
              <img
                src="/img/icons/right-arrow.svg"
                alt="arrow"
                className={classes.arrowIcon}
              />
            )}
            <img
              src={service.icon}
              alt={service?.image?.imageTag}
              className={classes.serviceIcon}
            />
            <h4 className={classes.serviceName} title={service?.title}>
              {service?.title}
            </h4>
          </div>
        ))}
      </div>
      <div className={classes.viewAll}>
        <button
          onClick={() => {
            const yPos = window.scrollY;
            sessionStorage.setItem("scrollTargetY", yPos.toString());
            sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
            navigate("/services");
            setIsBackNavigation(true)
          }}
          className="border-primary-500 primaryHover"
          data-aos="fade-down"
          data-aos-delay="150"
        >
          View All Services
        </button>
      </div>
    </div>
  );
};

export default Services;
